export const VEHICLE_DESCRIPTION = 'vehicle-description'
export const TIRE_SIZE = 'Tire Size: '
export const ICON_TRAILER = 'icon-trailer'
export const TRAILER_IMAGE_ALT_TEXT = 'Trailer'
export const CAR_BAR = 'carBar'
